var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { StyleService } from './style.service';
import { Renderer2 } from '@angular/core';
var BrowserStyleService = /** @class */ (function (_super) {
    __extends(BrowserStyleService, _super);
    function BrowserStyleService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrowserStyleService.prototype.addClass = function (renderer, component, className) {
        renderer.addClass(document.getElementsByTagName(component).item(0), className);
    };
    BrowserStyleService.prototype.removeClass = function (renderer, component, className) {
        renderer.removeClass(document.getElementsByTagName(component).item(0), className);
    };
    return BrowserStyleService;
}(StyleService));
export { BrowserStyleService };
